import { Separator, type SeparatorProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends SeparatorProps {}

export default forwardRef<HTMLHRElement, Props>((props, ref) => {
  return (
    <Separator
      ref={ref}
      // borderColor={{ base: 'rgba(23, 23, 23, 0.1)', _dark: 'rgba(255, 255, 255, 0.16)' }}
      {...props}
    />
  )
})
